import type { Session } from "@supabase/supabase-js";
import {
  createContext,
  type ReactNode,
  use,
  useEffect,
  useState,
} from "react";
import { supabase } from "./supabase";

type SessionState = {
  session: Session | null;
  isLoading: boolean;
};

const SessionContext = createContext<SessionState>({
  session: null,
  isLoading: true,
});

export const SessionProvider = ({ children }: { children: ReactNode }) => {
  const [state, setState] = useState<SessionState>({
    session: null,
    isLoading: true,
  });

  useEffect(() => {
    // Two reads, not one: getSession answers for the session already in
    // storage, and the subscription catches the one that arrives from the
    // OAuth redirect a moment later.
    supabase.auth
      .getSession()
      .then(({ data }) => setState({ session: data.session, isLoading: false }));

    const { data } = supabase.auth.onAuthStateChange((_event, session) => {
      setState({ session, isLoading: false });
    });

    return () => data.subscription.unsubscribe();
  }, []);

  return <SessionContext value={state}>{children}</SessionContext>;
};

export const useSession = (): SessionState => use(SessionContext);
